import { MobModel } from "types";

import acelaPilotImage from "assets/mob-acela-pilot.svg";
import acelaShipImage from "assets/mob-acela-ship.svg";
import breedenPilotImage from "assets/mob-breeden-pilot.svg";
import breedenShipImage from "assets/mob-breeden-ship.svg";
import hadronPilotImage from "assets/mob-hadron-pilot.svg";
import hadronShipImage from "assets/mob-hadron-ship.svg";
import megamaPilotImage from "assets/mob-megama-pilot.svg";
import megamaShipImage from "assets/mob-megama-ship.svg";
import revinPilotImage from "assets/mob-revin-pilot.svg";
import revinShipImage from "assets/mob-revin-ship.svg";
import valeraPilotImage from "assets/mob-valera-pilot.svg";
import valeraShipImage from "assets/mob-valera-ship.svg";

import { BASE_STATS } from "data/baseStats";

const { FIREPOWER, RESILIENCE, SPEED, PRECISION, ENERGY } = BASE_STATS;

// SECTOR TIER 2 - MEDALLION RANGE: 21-80

const BISHOP_STRAYHOLD_MOBS: Record<string, MobModel> = {
  hadron: {
    name: "Hadron",
    images: {
      ship: hadronShipImage,
      pilot: hadronPilotImage,
    },
    dialogs: {
      opening:
        "I guess have enough ...energy... to fight you. Get it? Because my ship has a lot of antimatter energy.",
      win: "I should stop working on puns and work more on my ship.",
      lose: "You didn't get it.",
    },
    position: 40,
    heightPercentage: 35,
    medallions: 24,
    baseStatsModifiers: {
      firepower: 2,
      resilience: 4,
      speed: 3,
      precision: 1,
      energy: 5,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 2,
      speed: 2,
      precision: 3,
      energy: 1,
    },
    baseStatsTargets: [ENERGY, SPEED, FIREPOWER, PRECISION, RESILIENCE],
    isBoss: false,
    drops: {
      platinum: "aether_nexus",
      gold: "velo_nexus",
      silver: "bulwark",
      bronze: "jetsetter",
    },
    installedUpgrades: {
      weapons: null,
      shields: "bulwark",
      thrusters: "jetsetter",
      targetingSystem: null,
      reactorCore: "aether_nexus",
    },
    partPositions: {
      weapons: { x: 71, y: 56.75 },
      targeting: { x: 82, y: 56.75 },
      thrusters: { x: 21.5, y: 50 },
    },
    skills: ["energyBlast"],
  },
  acela: {
    name: "Acela",
    images: {
      ship: acelaShipImage,
      pilot: acelaPilotImage,
    },
    dialogs: {
      opening:
        "They call me: Death by a Thousand Laser... Cuts. We're workshopping it.",
      win: "I guess my new nickname should be: I Suck. I'm not good at nicknames.",
      lose: "Okay that's done, now I can go back to workshopping nicknames. You got any ideas?",
    },
    position: 80,
    heightPercentage: 35,
    medallions: 30,
    baseStatsModifiers: {
      firepower: 4,
      resilience: 2,
      speed: 5,
      precision: 3,
      energy: 1,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 2,
      speed: 1,
      precision: 2,
      energy: 3,
    },
    baseStatsTargets: [SPEED, ENERGY, PRECISION, RESILIENCE, FIREPOWER],
    isBoss: false,
    drops: {
      platinum: "novaburner",
      gold: "hyperburner",
      silver: "light_laser",
      bronze: "fader_grid",
    },
    installedUpgrades: {
      weapons: "light_laser",
      shields: null,
      thrusters: "novaburner",
      targetingSystem: "fader_grid",
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 63, y: 55.25 },
      targeting: { x: 73, y: 55.25 },
      thrusters: { x: 29, y: 50.25 },
    },
    skills: ["rapidFire"],
  },
  megama: {
    name: "Megama",
    images: {
      ship: megamaShipImage,
      pilot: megamaPilotImage,
    },
    dialogs: {
      opening:
        "Can your weapons even pierce my dope as hell shields? You're welcome to try.",
      win: "I guess I need to upgrade my shields.",
      lose: "I tried to warn you about my shields. I'm pretty into my shields as you can tell.",
    },
    position: 120,
    heightPercentage: 35,
    medallions: 38,
    baseStatsModifiers: {
      firepower: 1,
      resilience: 5,
      speed: 2,
      precision: 4,
      energy: 3,
    },
    baseStatsCosts: {
      firepower: 3,
      resilience: 1,
      speed: 2,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [RESILIENCE, FIREPOWER, ENERGY, SPEED, PRECISION],
    isBoss: false,
    drops: {
      platinum: "light_sentinel",
      gold: "force_sanctuary",
      silver: "wave_grid",
      bronze: "blaze_reactor",
    },
    installedUpgrades: {
      weapons: null,
      shields: "light_sentinel",
      thrusters: null,
      targetingSystem: "wave_grid",
      reactorCore: "blaze_reactor",
    },
    partPositions: {
      weapons: { x: 80, y: 59.75 },
      targeting: { x: 91, y: 59.75 },
      thrusters: { x: 13, y: 50.75 },
    },
    skills: ["emergencyRepairs"],
  },
  breeden: {
    name: "Breeden",
    images: {
      ship: breedenShipImage,
      pilot: breedenPilotImage,
    },
    dialogs: {
      opening: "Precision is the best attribute a pilot can have.",
      win: "Maybe being precise isn't all that useful. Oh my god, my identity.",
      lose: "Precisely.",
    },
    position: 160,
    heightPercentage: 35,
    medallions: 48,
    baseStatsModifiers: {
      firepower: 3,
      resilience: 1,
      speed: 4,
      precision: 5,
      energy: 2,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 3,
      speed: 2,
      precision: 1,
      energy: 2,
    },
    baseStatsTargets: [SPEED, FIREPOWER, PRECISION, RESILIENCE, ENERGY],
    isBoss: false,
    drops: {
      platinum: "stellar_sight",
      gold: "needle_grid",
      silver: "jetflare",
      bronze: "star_beam",
    },
    installedUpgrades: {
      weapons: "star_beam",
      shields: null,
      thrusters: "jetflare",
      targetingSystem: "stellar_sight",
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 71, y: 58.5 },
      targeting: { x: 81.5, y: 58.5 },
      thrusters: { x: 19.5, y: 51.25 },
    },
    skills: ["pressurePoint"],
  },
  revin: {
    name: "Revin",
    images: {
      ship: revinShipImage,
      pilot: revinPilotImage,
    },
    dialogs: {
      opening:
        "Sure, let's fight, I've got 5 seconds to spare. Oh, sorry, that might've come off rude.",
      win: "Oh wow, that was unexpected! ...Again, no offense intended.",
      lose: "Hey, you tried and that's ...something. I promise I'm not trying to be condescending.",
    },
    position: 200,
    heightPercentage: 35,
    medallions: 62,
    baseStatsModifiers: {
      firepower: 5,
      resilience: 3,
      speed: 1,
      precision: 2,
      energy: 4,
    },
    baseStatsCosts: {
      firepower: 1,
      resilience: 2,
      speed: 3,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [RESILIENCE, FIREPOWER, SPEED, PRECISION, ENERGY],
    isBoss: false,
    drops: {
      platinum: "star_breaker",
      gold: "moon_shot",
      silver: "glow_reactor",
      bronze: "energy_barrier",
    },
    installedUpgrades: {
      weapons: "star_breaker",
      shields: "energy_barrier",
      thrusters: null,
      targetingSystem: null,
      reactorCore: "glow_reactor",
    },
    partPositions: {
      weapons: { x: 49, y: 55.75 },
      targeting: { x: 67, y: 55.75 },
      thrusters: { x: 23, y: 49 },
    },
    skills: ["shieldBreaker"],
  },
  valera: {
    name: "Valera",
    images: {
      ship: valeraShipImage,
      pilot: valeraPilotImage,
    },
    dialogs: {
      opening: "You want to fight ...me? Uh, good luck, I guess.",
      win: "Well, damn.",
      lose: "lol",
    },
    position: 240,
    heightPercentage: 35,
    medallions: 80,
    baseStatsModifiers: {
      firepower: 3,
      resilience: 4,
      speed: 4,
      precision: 2,
      energy: 2,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 2,
      speed: 1,
      precision: 2,
      energy: 3,
    },
    baseStatsTargets: [RESILIENCE, FIREPOWER, PRECISION, ENERGY, SPEED],
    isBoss: false,
    drops: {
      platinum: "void_drive",
      gold: "vision_wall",
      silver: "quantum_blade",
      bronze: "photon_sight",
    },
    installedUpgrades: {
      weapons: "quantum_blade",
      shields: "vision_wall",
      thrusters: "void_drive",
      targetingSystem: "photon_sight",
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 53, y: 58.5 },
      targeting: { x: 63.5, y: 58.5 },
      thrusters: { x: 20.5, y: 51.75 },
    },
    skills: ["rapidFire", "emergencyRepairs"],
  },
};

export default BISHOP_STRAYHOLD_MOBS;
